import {defineMessages} from 'react-intl';

export default defineMessages({
    basics: {
        id: 'gui.actorLibrary.tagBasics',
        defaultMessage: 'Basics',
        description: 'Tag for basic built-in Amethyst actors'
    },
    shapes: {
        id: 'gui.actorLibrary.tagShapes',
        defaultMessage: 'Shapes',
        description: 'Tag for built-in shape actors'
    },
    blank: {
        id: 'gui.actorLibrary.tagBlank',
        defaultMessage: 'Blank',
        description: 'Tag for creating an actor without a model'
    }
});
